import { getCapitalizedString } from "./index";
export function getFormatedString(input_string) {
  if (!input_string || !(typeof input_string === "string")) {
    return "";
  }
  const string = input_string.replace(/_/g, " ");
  return getCapitalizedString(string);
}
